import * as React from 'react';
import { ClickAwayListener, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';

function arrowGenerator(color: string) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.95em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${color} transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.95em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `${color} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.95em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 1em 1em 0',
        borderColor: `transparent ${color} transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.95em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 0 1em 1em',
        borderColor: `transparent transparent transparent ${color}`,
      },
    },
  };
}

const styles = (theme: Theme) =>
  createStyles({
    htmlPopper: arrowGenerator('#dadde9'),
    htmlTooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
      '& b': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    arrow: {
      position: 'absolute',
      fontSize: 6,
      width: '3em',
      height: '3em',
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid',
      },
    },
    info: {
      cursor: 'pointer',
      color: 'rgb(102, 102, 102)',
      marginLeft: '4px',
    },
  });

interface Props extends WithStyles<typeof styles> {
  html: string;
}

interface State {
  open: boolean;
}

class HtmlToolTip extends React.PureComponent<Props, State> {
  public state: State = {
    open: false,
  };
  private arrowRef = React.createRef<HTMLElement>();

  public render() {
    const { classes, html } = this.props;
    return (
      <ClickAwayListener onClickAway={this.handleTooltipClose}>
        <Tooltip
          disableFocusListener
          disableHoverListener
          disableTouchListener
          onClose={this.handleTooltipClose}
          open={this.state.open}
          classes={{
            popper: classes.htmlPopper,
            tooltip: classes.htmlTooltip,
          }}
          PopperProps={{
            popperOptions: {
              modifiers: {
                arrow: {
                  enabled: Boolean(this.arrowRef.current),
                  element: this.arrowRef.current,
                },
              },
            },
          }}
          title={
            <React.Fragment>
              <div dangerouslySetInnerHTML={{ __html: html }} />
              <span className={classes.arrow} ref={this.arrowRef} />
            </React.Fragment>
          }
        >
          <InfoOutlined color="inherit" className={classes.info} onClick={this.handleTooltipOpen} />
        </Tooltip>
      </ClickAwayListener>
    );
  }

  private handleTooltipOpen = () => {
    this.setState({ open: true });
  };

  private handleTooltipClose = () => {
    this.setState({ open: false });
  };
}

export default withStyles(styles)(HtmlToolTip);



// WEBPACK FOOTER //
// ./src/components/HtmlToolTip.tsx